import { Paper } from '@mui/material'
import { useEffect } from 'react'
import { NavTabs, useNavTabs } from '../../../components/navigation/NavTabs'
import { MISSIONS_TABS } from '../../../components/navigation/tabs'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import { ClaimMissionAnimation } from '../components/missions/ClaimMissionAnimation'
import { AchievementsTab } from './AchievementsTab'
import { MissionsTab } from './MissionsTab'

const MISSIONS_CONTENT = {
    missions: <MissionsTab />,
    achievements: <AchievementsTab />,
}

export const Missions = () => {
    const getMissions = useStoreActions((state) => state.missionsService.getMissions)
    const isCompletedMissions = useStoreState((state) => state.missionsService.isCompletedMissions)
    const { currentTab } = useNavTabs(MISSIONS_TABS)

    // const achievements = useStoreState((state) => state.missionsService.achievements)
    const badges = {
        missions: isCompletedMissions,
    }

    useEffect(() => {
        getMissions()
    }, [])

    return (
        <>
            <NavTabs tabs={MISSIONS_TABS} badges={badges} />
            <br />
            <Paper
                id="missions-UI"
                sx={{
                    display: 'flex',
                    padding: 0,
                    '> div': {
                        padding: 1.5,
                    },
                    flexGrow: 1,
                    overflowY: 'auto',
                    position: 'relative',
                    height: '100%',
                    backgroundColor: 'background.default',
                }}
            >
                {MISSIONS_CONTENT[currentTab]}
            </Paper>
            <ClaimMissionAnimation />
        </>
    )
}
